"use client";
import { j as e } from "./index.es73.js";
import { forwardRef as c } from "react";
import { composeClassNames as b } from "./index.es139.js";
import n from "./index.es140.js";
c(
  ({
    label: a,
    type: i = "text",
    value: r,
    placeholder: t,
    onChange: o,
    state: s,
    message: l,
    isDisabled: m,
    ...p
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    a,
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ...p,
        ref: d,
        className: b(
          "bl-input",
          s && `bl-input--${s}`,
          "bl-m-t-1"
        ),
        onChange: o,
        type: i,
        value: r,
        disabled: m,
        placeholder: t
      }
    ),
    l && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(n, { state: s, children: l }) })
  ] }) })
);
//# sourceMappingURL=index.es76.js.map
